// Library Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

// Local Imports
import endPoints from '../../constant';
import axiosInstance from '../../http';

export interface InitialStateProps {
  allBookings?: any;
  loading?: boolean;
  error?: string | null;
  linkLoading?: boolean;
  linkError?: string | null;
}

const initialState: InitialStateProps = {
  allBookings: [],
  loading: false,
  error: null,
  linkLoading: false,
  linkError: null
};

// All Salons API Calling
export const allBookingsAPI = createAsyncThunk(
  'dashboard/bookings',
  async (values: any, { rejectWithValue }) => {
    try {
      let updatedEndPoint = endPoints.allBookingsListing;
      const searchEnpoint = `${endPoints.allBookingsListing}/?search=${values?.search}`;
      if (values?.search) {
        updatedEndPoint = searchEnpoint;
      }
      if (values?.pastBookings) {
        updatedEndPoint = `${endPoints.allBookingsListing}/?pastBooking=${values?.pastBookings}`;
      }
      if (values?.upcomingBookings) {
        updatedEndPoint = `${endPoints.allBookingsListing}/?upcomingBooking=${values?.upcomingBookings}`;
      }
      const { data } = await axiosInstance.get(updatedEndPoint);
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(error?.message + '. Please check your Internet Connection!');
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

export const getBookingLink = createAsyncThunk(
  'dashboard/bookingLink',
  async (values: any, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(endPoints.bookingLink, {
        ...values
      });
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(error?.message + '. Please check your Internet Connection!');
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// All Salons API Calling
export const userBookingsAPI = createAsyncThunk(
  'dashboard/userBookings',
  async (userId: string, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(endPoints.userBooking + '/' + userId);
      return data;
    } catch (error: any) {
      if (error?.message === 'Network Error') {
        return rejectWithValue(error?.message + '. Please check your Internet Connection!');
      } else {
        return rejectWithValue(error?.response?.data?.error?.message);
      }
    }
  }
);

// Bookings Slice
export const bookingsSlice = createSlice({
  name: 'dashboard/bookings',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(allBookingsAPI.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(allBookingsAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.allBookings = action.payload;
        state.error = null;
      })
      .addCase(allBookingsAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as any;
      })
      .addCase(getBookingLink.pending, state => {
        state.linkLoading = true;
        state.linkError = null;
      })
      .addCase(getBookingLink.fulfilled, (state, action) => {
        state.linkLoading = false;
        state.linkError = null;
      })
      .addCase(getBookingLink.rejected, (state, action) => {
        state.linkLoading = false;
        state.linkError = action.payload as any;
      })
      .addCase(PURGE, state => {
        state.allBookings = [];
      });
  }
});

// Action creators are generated for each case reducer function
// export const {  } = bookingsSlice.actions;

export default bookingsSlice.reducer;
